import { render, staticRenderFns } from "./FakeSimulation.vue?vue&type=template&id=917f36e8&"
import script from "./FakeSimulation.vue?vue&type=script&lang=js&"
export * from "./FakeSimulation.vue?vue&type=script&lang=js&"
import style0 from "./FakeSimulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports